module.exports = __webpack_public_path__ + "static/media/headbanner3.b72a9544.mp4";